"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.excludeFromList = exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));

var _isEqual = _interopRequireDefault(require("lodash/fp/isEqual"));

var _map = _interopRequireDefault(require("lodash/fp/map"));

var _find = _interopRequireDefault(require("lodash/fp/find"));

var _orderBy = _interopRequireDefault(require("lodash/fp/orderBy"));

var _isObject = _interopRequireDefault(require("lodash/fp/isObject"));

var _debounce = _interopRequireDefault(require("lodash/fp/debounce"));

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _without = _interopRequireDefault(require("lodash/fp/without"));

var _countBy = _interopRequireDefault(require("lodash/fp/countBy"));

var _getOr = _interopRequireDefault(require("lodash/fp/getOr"));

var _flow = _interopRequireDefault(require("lodash/fp/flow"));

var _filter = _interopRequireDefault(require("lodash/fp/filter"));

var _size = _interopRequireDefault(require("lodash/fp/size"));

var _stubTrue = _interopRequireDefault(require("lodash/fp/stubTrue"));

var _omit = _interopRequireDefault(require("lodash/fp/omit"));

var _negate = _interopRequireDefault(require("lodash/fp/negate"));

var _TreeSearch = _interopRequireDefault(require("./TreeSearch"));

var _TreeSelectAll = _interopRequireDefault(require("./TreeSelectAll"));

var _TreeSummary = _interopRequireDefault(require("./TreeSummary"));

var _TreeNodeContainer = _interopRequireDefault(require("./TreeNodeContainer"));

var _TreeNode = _interopRequireDefault(require("./TreeNode"));

var _TreeLeafList = _interopRequireDefault(require("./TreeLeafList"));

var _TreeNothingFound = _interopRequireDefault(require("./TreeNothingFound"));

var _TreeOptions = _interopRequireDefault(require("./TreeOptions"));

var _TreeRoot = _interopRequireDefault(require("./TreeRoot"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var SEARCH_DEBOUNCE = 100;
var otherwise = _stubTrue.default;
var notEqual = (0, _negate.default)(_isEqual.default);
var notEmpty = (0, _negate.default)(_isEmpty.default);

var isNameObject = function isNameObject(item) {
  return (0, _isObject.default)(item.name);
};

var getFullName = function getFullName(item) {
  return "".concat(item.name.firstName, " ").concat(item.name.lastName);
};

var getName = function getName(item) {
  return isNameObject(item) ? getFullName(item) : item.name;
};

var getLowerCaseName = function getLowerCaseName(item) {
  return (0, _getOr.default)('', 'name')(item).toLowerCase();
};

var getLowerCaseLastName = function getLowerCaseLastName(item) {
  return (0, _getOr.default)('', 'name.lastName')(item).toLowerCase();
};

var orderByName = (0, _orderBy.default)([function (item) {
  return isNameObject(item) ? getLowerCaseLastName(item) : getLowerCaseName(item);
}], ['asc']);
var filterEmptyGroups = (0, _filter.default)(function (group) {
  return notEmpty(group.items);
});

var sortGroupsByName = function sortGroupsByName(groups) {
  var fixedGroups = {};
  var sortableGroups = {};
  (0, _map.default)(function (group) {
    if (group.position === 'last') {
      fixedGroups[group.id] = _objectSpread({}, group);
    } else {
      sortableGroups[group.id] = _objectSpread({}, group);
    }
  })(groups);
  var sortedGroups = orderByName(sortableGroups);
  return (0, _isEmpty.default)(fixedGroups) ? sortedGroups : _objectSpread(_objectSpread({}, sortedGroups), fixedGroups);
};

var sortGroupItemsByName = function sortGroupItemsByName(groups) {
  var sortedGroups = {};
  (0, _map.default)(function (group) {
    sortedGroups[group.id] = _objectSpread(_objectSpread({}, group), {}, {
      items: orderByName(group.items)
    });
  })(groups);
  return sortedGroups;
};

var getMappedItemsToGroups = function getMappedItemsToGroups(groups, items) {
  var mappedGroups = {}; // build an object for listing the groups by id

  groups.forEach(function (group) {
    mappedGroups[group.id] = _objectSpread(_objectSpread({}, group), {}, {
      items: []
    });
  });
  items.forEach(function (item) {
    // add items to the respective group
    var groupIds = item.groupIds || [];
    groupIds.forEach(function (groupId) {
      var mappedGroup = mappedGroups[groupId];

      if (mappedGroup) {
        mappedGroup.items.push(item);
      }
    });
  });
  return mappedGroups;
};

var filterByName = function filterByName(searchValue) {
  return function (item) {
    if (searchValue) {
      return getName(item).toLowerCase().includes(searchValue.toLowerCase());
    }

    return true;
  };
};

var filterOutByItemId = function filterOutByItemId(list) {
  return function (item) {
    return !list.includes(item.id);
  };
};

var containsItemById = function containsItemById(list) {
  return function (item) {
    return list.includes(item.id);
  };
};

var getFlatItems = function getFlatItems(items, searchValue) {
  return (0, _flow.default)((0, _filter.default)(filterByName(searchValue)), orderByName)(items);
};

var getListIds = function getListIds(list) {
  return list.map(function (listItem) {
    return listItem.id;
  });
};

var excludeFromList = function excludeFromList(list, itemId) {
  return list.filter(function (item) {
    return item !== itemId;
  });
};

exports.excludeFromList = excludeFromList;

var getAssetTypeCounts = function getAssetTypeCounts(items) {
  return (0, _countBy.default)(function (item) {
    return item.type;
  }, items);
};

var debounceFn = function debounceFn(fn) {
  return (0, _debounce.default)(SEARCH_DEBOUNCE, fn);
};

var filterProps = (0, _omit.default)(['expandedGroups', 'onExpandGroupsChange', 'onSearchChange', 'onSelectionChange', 'treeOptions']);

var customCompare = function customCompare(prevProps, nextProps) {
  return (0, _isEqual.default)(filterProps(prevProps), filterProps(nextProps));
};

var assetCounted = function assetCounted(payload) {
  return {
    type: 'assetCounted',
    payload: payload
  };
};

var allChecked = function allChecked(payload) {
  return {
    type: 'allChecked',
    payload: payload
  };
};

var searchValueChanged = function searchValueChanged(payload) {
  return {
    type: 'searchValueChanged',
    payload: payload
  };
};

var flatItemsChanged = function flatItemsChanged(payload) {
  return {
    type: 'flatItemsChanged',
    payload: payload
  };
};

var groupedItemsChanged = function groupedItemsChanged(payload) {
  return {
    type: 'groupedItemsChanged',
    payload: payload
  };
};

var treeReducer = function treeReducer(state, action) {
  switch (action.type) {
    case 'assetCounted':
      return _objectSpread(_objectSpread({}, state), {}, {
        assetCounts: action.payload
      });

    case 'allChecked':
      return _objectSpread(_objectSpread({}, state), {}, {
        allChecked: action.payload
      });

    case 'searchValueChanged':
      return _objectSpread(_objectSpread({}, state), {}, {
        searchValue: action.payload,
        allChecked: false
      });

    case 'flatItemsChanged':
      return _objectSpread(_objectSpread({}, state), {}, {
        flatItems: action.payload
      });

    case 'groupedItemsChanged':
      return _objectSpread(_objectSpread({}, state), {}, {
        groupedItems: action.payload
      });

    default:
      throw new Error();
  }
};

var Tree = /*#__PURE__*/_react.default.memo(function (props) {
  var groups = props.groups,
      items = props.items,
      selectedGroups = props.selectedGroups,
      selectedItems = props.selectedItems,
      onSelectionChange = props.onSelectionChange,
      hasMultiselect = props.hasMultiselect,
      showRadioButtons = props.showRadioButtons,
      hideSearch = props.hideSearch,
      hideTreeHead = props.hideTreeHead,
      summary = props.summary,
      hideSummary = props.hideSummary,
      search = props.search,
      searchPlaceholder = props.searchPlaceholder,
      onSearchChange = props.onSearchChange,
      className = props.className,
      scrollHeight = props.scrollHeight,
      expandedGroups = props.expandedGroups,
      onExpandGroupsChange = props.onExpandGroupsChange,
      showEmptyGroups = props.showEmptyGroups,
      treeOptions = props.treeOptions;

  var _useReducer = (0, _react.useReducer)(treeReducer, {
    groupedItems: [],
    flatItems: [],
    allChecked: false,
    searchValue: '',
    assetCounts: {}
  }),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var treeRef = (0, _react.useRef)();
  var previousItems = (0, _react.useRef)();
  var previousGroups = (0, _react.useRef)();
  var previousSearchValue = (0, _react.useRef)('');
  var internalExpandedGroups = (0, _react.useRef)(expandedGroups);
  (0, _react.useEffect)(function () {
    // Update Tree when items or groups have changed
    if (notEqual(previousItems.current, items) || notEqual(previousGroups.current, groups)) {
      previousItems.current = items;
      previousGroups.current = groups;
      dispatch(assetCounted(getAssetTypeCounts(items)));
      dispatch(allChecked(checkAllSelected({
        items: items,
        groups: groups,
        selectedItems: selectedItems,
        selectedGroups: selectedGroups
      }, state.flatItems)));
      makeTree(groups, items);
    }
  }, [items, groups]);
  var debouncedMakeTree = debounceFn(function (g, i) {
    return makeTree(g, i);
  });
  (0, _react.useEffect)(function () {
    // To prevent executing the effect on first render, use a ref to check previous render values
    if (notEqual(previousSearchValue.current, state.searchValue)) {
      debouncedMakeTree(groups, items);
      previousSearchValue.current = state.searchValue;
    }
  }, [state.searchValue]);
  (0, _react.useEffect)(function () {
    makeTree(groups, items);
  }, [showEmptyGroups]);

  var checkAllSelected = function checkAllSelected(updatedProps, flatItems) {
    var updatedItems = updatedProps.items,
        updatedGroups = updatedProps.groups,
        updatedSelectedItems = updatedProps.selectedItems,
        updatedSlectedGroups = updatedProps.selectedGroups;

    if (!hasGroups() && (0, _isEmpty.default)(updatedSelectedItems) || hasNoSearchAndGroups() && (0, _isEmpty.default)(updatedSlectedGroups) || hasSearchAndGroups() && (0, _isEmpty.default)(updatedSelectedItems)) {
      return false;
    }

    if (hasNoSearchAndGroups()) {
      var unselectedGroups = (0, _filter.default)(filterOutByItemId(updatedSlectedGroups))(updatedGroups);
      return (0, _isEmpty.default)(unselectedGroups);
    } else if (hasSearchAndGroups()) {
      var unselectedSearchItems = (0, _filter.default)(filterOutByItemId(updatedSelectedItems))(flatItems);
      return (0, _isEmpty.default)(unselectedSearchItems);
    }

    var unselectedItems = updatedItems.filter(filterOutByItemId(updatedSelectedItems));
    return (0, _isEmpty.default)(unselectedItems);
  };

  var handleToggleNode = function handleToggleNode(nodeId) {
    var newExpandedNodes = internalExpandedGroups.current.includes(nodeId) ? internalExpandedGroups.current.filter(function (item) {
      return item !== nodeId;
    }) : [].concat((0, _toConsumableArray2.default)(internalExpandedGroups.current), [nodeId]); // Performance improvement to skip on render cycle and change "open" class directly

    if (internalExpandedGroups.current.includes(nodeId)) {
      getNodeContainerDomElementById(nodeId).classList.remove('open');
    } else {
      getNodeContainerDomElementById(nodeId).classList.add('open');
    }

    internalExpandedGroups.current = newExpandedNodes;
    onExpandGroupsChange(newExpandedNodes);
  };

  var getNodeContainerDomElementById = function getNodeContainerDomElementById(nodeId) {
    return treeRef.current.querySelector(".TreeNodeContainer[data-id=\"".concat(nodeId, "\"]"));
  };

  var selectAllSearchResultItems = function selectAllSearchResultItems(shouldSelect) {
    return selectAllFlatItems(shouldSelect);
  };

  var handeSelectAll = function handeSelectAll(shouldSelect, isIndeterminate) {
    var shouldSelectAll = shouldSelect && !isIndeterminate;
    dispatch(allChecked(shouldSelectAll));
    (0, _cond.default)([[hasNoSearchAndGroups, function () {
      return selectAllGroups(shouldSelectAll);
    }], [hasSearchAndGroups, function () {
      return selectAllSearchResultItems(shouldSelectAll);
    }], [otherwise, function () {
      return selectAllFlatItems(shouldSelectAll);
    }]])();
  };

  var selectAllGroups = function selectAllGroups(shouldSelect) {
    return respondSelection([], shouldSelect ? getListIds(groups) : []);
  };

  var selectAllFlatItems = function selectAllFlatItems(shouldSelect) {
    return respondSelection(shouldSelect ? getListIds(state.flatItems) : [], []);
  };

  var respondSelection = function respondSelection(updatedSelectedItems, updatedSelectedGroups) {
    onSelectionChange({
      items: updatedSelectedItems,
      groups: updatedSelectedGroups
    });
  };

  var handleGroupSelection = function handleGroupSelection(group, isIndeterminate) {
    var groupId = group.id;
    var isSelected = selectedGroups.includes(groupId);
    var shouldSelectGroup = !isSelected && !isIndeterminate; // handle group selection

    var newSelectedGroups = shouldSelectGroup ? [].concat((0, _toConsumableArray2.default)(selectedGroups), [groupId]) : excludeFromList(selectedGroups, groupId); // deselect all items of a node since they will be selected inherently via the group itself

    var itemsInGroup = (0, _find.default)(function (entry) {
      return entry.id === groupId;
    })(state.groupedItems);
    var itemIdsOfGroup = (0, _map.default)(function (item) {
      return item.id;
    })(itemsInGroup.items);
    var updatedSelectedItems = (0, _without.default)(itemIdsOfGroup, selectedItems);
    respondSelection(updatedSelectedItems, newSelectedGroups);
  };

  var handleSearchChange = function handleSearchChange(updatedSearchValue) {
    onSearchChange(updatedSearchValue);
    dispatch(searchValueChanged(updatedSearchValue));
  };

  var hasGroups = function hasGroups() {
    return groups && notEmpty(groups);
  };

  var hasSearchAndGroups = function hasSearchAndGroups() {
    return hasInternalSearchValue() && hasGroups();
  };

  var hasNoSearchAndGroups = function hasNoSearchAndGroups() {
    return !hasInternalSearchValue() && hasGroups();
  };

  var setFlatItemList = function setFlatItemList(updtedItems, searchValue) {
    var flatItems = getFlatItems(updtedItems, searchValue);
    dispatch(assetCounted(getAssetTypeCounts(flatItems)));
    dispatch(flatItemsChanged(flatItems));
  };

  var setGroupedItemList = function setGroupedItemList(groupsToProcess, itemsToProcess, considerEmptyGroups) {
    // Map items to groups with filtered items
    var mappedItemsToGroups = getMappedItemsToGroups(groupsToProcess, itemsToProcess);
    var newGroupedItems = (0, _flow.default)(sortGroupsByName, sortGroupItemsByName)(mappedItemsToGroups);
    var groupedItems = considerEmptyGroups ? newGroupedItems : filterEmptyGroups(newGroupedItems);
    dispatch(assetCounted(getAssetTypeCounts(items)));
    dispatch(groupedItemsChanged(groupedItems));
  };

  var makeTree = function makeTree(updatedGroups, updatedItems) {
    var internalSearchValue = state.searchValue;
    var groupsToProcess = updatedGroups;
    var itemsToProcess = updatedItems;

    var hasGroupList = function hasGroupList(groupList) {
      return groupList && notEmpty(groupList);
    };

    var hasNoInternalSearchAndGroups = function hasNoInternalSearchAndGroups() {
      return (0, _isEmpty.default)(internalSearchValue) && hasGroupList(groupsToProcess);
    };

    var hasInternalSearchAndGroups = function hasInternalSearchAndGroups() {
      return notEmpty(internalSearchValue) && hasGroupList(groupsToProcess);
    };

    var setGroupedItems = function setGroupedItems() {
      return setGroupedItemList(groupsToProcess, itemsToProcess, showEmptyGroups);
    };

    var setFlatItems = function setFlatItems() {
      return setFlatItemList(itemsToProcess, internalSearchValue);
    };

    (0, _cond.default)([[hasNoInternalSearchAndGroups, setGroupedItems], [hasInternalSearchAndGroups, setFlatItems], [otherwise, setFlatItems]])();
  };

  var renderTree = function renderTree() {
    var groupedItems = state.groupedItems;

    if ((0, _isEmpty.default)(groupedItems)) {
      return /*#__PURE__*/_react.default.createElement(_TreeNothingFound.default, null);
    }

    var result = (0, _map.default)(function (group) {
      var groupId = group.id;
      var groupItems = group.items;
      var isOpen = expandedGroups.includes(groupId);
      var numSelectedGroupItems = (0, _filter.default)(containsItemById(selectedItems))(groupItems).length;
      var isGroupSelected = selectedGroups.includes(groupId);
      var isIndeterminate = !isGroupSelected && numSelectedGroupItems > 0;
      return /*#__PURE__*/_react.default.createElement(_TreeNodeContainer.default, {
        key: groupId,
        groupId: groupId,
        isOpen: isOpen
      }, /*#__PURE__*/_react.default.createElement(_TreeNode.default, {
        node: group,
        hasMultiselect: hasMultiselect,
        onToggleNode: handleToggleNode,
        onSelect: handleGroupSelection,
        isSelected: isGroupSelected,
        isIndeterminate: isIndeterminate
      }), /*#__PURE__*/_react.default.createElement(_TreeLeafList.default, {
        leafList: groupItems,
        hasMultiselect: hasMultiselect,
        showRadioButtons: showRadioButtons,
        selectedItems: selectedItems,
        selectedGroups: selectedGroups,
        onSelectionChange: respondSelection
      }));
    })(groupedItems);
    return result;
  };

  var renderFlatList = function renderFlatList() {
    var flatItems = state.flatItems;
    var hasLeafs = (0, _isEmpty.default)(flatItems);

    var getLeafs = function getLeafs() {
      return /*#__PURE__*/_react.default.createElement(_TreeLeafList.default, {
        leafList: flatItems,
        hasMultiselect: hasMultiselect,
        showRadioButtons: showRadioButtons,
        selectedItems: selectedItems,
        selectedGroups: selectedGroups,
        onSelectionChange: respondSelection
      });
    };

    return /*#__PURE__*/_react.default.createElement(_TreeNodeContainer.default, {
      isOpen: true
    }, hasLeafs ? /*#__PURE__*/_react.default.createElement(_TreeNothingFound.default, null) : getLeafs());
  };

  var renderSummary = function renderSummary() {
    if (hideSummary) {
      return null;
    }

    return summary || /*#__PURE__*/_react.default.createElement(_TreeSummary.default, {
      assetCounts: state.assetCounts
    });
  };

  var hasExternalGroups = notEmpty(groups);

  var hasInternalSearchValue = function hasInternalSearchValue() {
    return notEmpty(state.searchValue);
  };

  var hasSelectedAllItems = function hasSelectedAllItems() {
    return (0, _isEqual.default)((0, _size.default)(selectedItems), (0, _size.default)(state.flatItems));
  };

  var hasPartialySelectedItems = function hasPartialySelectedItems() {
    return notEmpty(selectedItems) && !hasSelectedAllItems();
  };

  var hasSelectedAllGroups = function hasSelectedAllGroups() {
    return (0, _isEqual.default)((0, _size.default)(selectedGroups), (0, _size.default)(groups));
  };

  var hasPartialySelectedGroups = function hasPartialySelectedGroups() {
    return hasExternalGroups && notEmpty(selectedGroups) && !hasSelectedAllGroups();
  };

  var hasSearchAndNoItems = hasInternalSearchValue() && (0, _isEmpty.default)(state.flatItems);
  var hasSearchAndNoGroups = hasInternalSearchValue() && (0, _isEmpty.default)(state.groupedItems) && hasExternalGroups;
  var hideSelectAll = hasSearchAndNoItems || hasSearchAndNoGroups;
  var isIndeterminate = hasPartialySelectedGroups() || hasPartialySelectedItems();
  var treeClassNames = (0, _classnames.default)('Tree', className);
  var treeHeadClasses = (0, _classnames.default)('TreeHead', 'display-flex align-items-center', 'padding-15');

  var shouldRenderTree = function shouldRenderTree() {
    return hasGroups() && !hasInternalSearchValue();
  };

  var content = (0, _cond.default)([[shouldRenderTree, function () {
    return renderTree();
  }], [otherwise, function () {
    return renderFlatList();
  }]])();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: treeClassNames,
    ref: treeRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'TreeHeader'
  }, !hideSearch && !search && /*#__PURE__*/_react.default.createElement(_TreeSearch.default, {
    value: state.searchValue,
    onChange: handleSearchChange,
    placeholder: searchPlaceholder
  }), search && search, !hideTreeHead && /*#__PURE__*/_react.default.createElement("div", {
    className: treeHeadClasses
  }, !hideSelectAll && /*#__PURE__*/_react.default.createElement(_TreeSelectAll.default, {
    isChecked: state.allChecked,
    isEnabled: hasMultiselect,
    isIndeterminate: isIndeterminate,
    onSelect: handeSelectAll
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'display-flex flex-row justify-content-between width-100pct'
  }, renderSummary(), /*#__PURE__*/_react.default.createElement(_TreeOptions.default, {
    treeOptions: treeOptions
  })))), /*#__PURE__*/_react.default.createElement(_TreeRoot.default, {
    maxHeight: scrollHeight
  }, content));
}, customCompare);

Tree.displayName = 'Tree';
Tree.defaultProps = {
  hasMultiselect: true,
  showRadioButtons: false,
  hideSearch: false,
  hideSummary: false,
  showEmptyGroups: true,
  selectedGroups: [],
  selectedItems: [],
  onSelectionChange: function onSelectionChange() {},
  onExpandGroupsChange: function onExpandGroupsChange() {},
  onSearchChange: function onSearchChange() {},
  searchPlaceholder: 'Type here to filter by name',
  treeOptions: [],
  groups: []
};
Tree.propTypes = {
  groups: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    name: _propTypes.default.string.isRequired,
    icon: _propTypes.default.string,
    className: _propTypes.default.string
  })),
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
      firstName: _propTypes.default.string,
      lastName: _propTypes.default.string.isRequired
    })]).isRequired,
    info: _propTypes.default.string,
    type: _propTypes.default.string.isRequired,
    groupIds: _propTypes.default.arrayOf(_propTypes.default.string),
    className: _propTypes.default.string
  })),
  selectedGroups: _propTypes.default.arrayOf(_propTypes.default.string),
  selectedItems: _propTypes.default.arrayOf(_propTypes.default.string),
  onSelectionChange: _propTypes.default.func,
  hasMultiselect: _propTypes.default.bool,
  showRadioButtons: _propTypes.default.bool,
  hideSearch: _propTypes.default.bool,
  summary: _propTypes.default.node,
  hideSummary: _propTypes.default.bool,
  hideTreeHead: _propTypes.default.bool,
  // This defines a custom search component.
  search: _propTypes.default.node,
  searchPlaceholder: _propTypes.default.string,
  onSearchChange: _propTypes.default.func,
  className: _propTypes.default.string,
  scrollHeight: _propTypes.default.number,
  expandedGroups: _propTypes.default.arrayOf(_propTypes.default.string),
  onExpandGroupsChange: _propTypes.default.func,
  showEmptyGroups: _propTypes.default.bool,
  treeOptions: _propTypes.default.arrayOf(_propTypes.default.node)
};
var _default = Tree;
exports.default = _default;